// FINANCE BATCH 1 (item 1.2c) — "today" on a form is the India date, not the browser's UTC date.
// new Date().toISOString() is UTC, so after 5:30am IST... fine, but before 5:30am IST it shows
// yesterday for a user in India, and it shows the wrong day for anyone outside IST.
export function istToday() {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  return `${get("year")}-${get("month")}-${get("day")}`;
}

export default istToday;

// Today in India shifted by N days, still as YYYY-MM-DD (date pickers' min/max).
export function istDatePlus(days) {
  const [y, m, d] = istToday().split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + Number(days || 0)));
  return dt.toISOString().split("T")[0];
}
